$ = require 'jquery'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
Controller = require 'controller'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
l = require 'lib/localize'
boardMenuVisTemplate = require 'views/templates/board_menu_vis'
{ featureFlagClient } = require 'common/lib/feature-flag-client'

module.exports = class BoardOrgSelectPermLevelView extends View

  viewTitleKey: 'change visibility'

  tagName: 'ul'

  events:
    'click .js-select': 'selectVis'

  className: 'pop-over-list'

  render: ->
    org = @options.organization

    if !org.canSetVisibility('private') && !org.canSetVisibility('org') && (
      !org.canSetVisibility('enterprise') || !featureFlagClient.get('enterprise.company_visible_boards', false)
    ) &&
    !org.canSetVisibility('public')
      data =
        isOrgAdmin: org.owned()
        orgSettingsUrl: Controller.getOrganizationAccountUrl(org)
        organization: org.toJSON()
      @$el.html(
        templates.fill(
          'cant_add_board_to_org'
          data
        )
      )
    else
      current = @model.getPref('permissionLevel')
      enterprise = org?.getEnterprise()

      @$el.html boardMenuVisTemplate
        current: current
        canChange: true
        mustChange: !org.canSetVisibility(current)
        hasSuperAdmins: org.isFeatureEnabled('superAdmins')
        hasOrg: true
        orgName: org.get('displayName')
        privateRestricted: !org.canSetVisibility('private')
        orgRestricted: !org.canSetVisibility('org')
        enterpriseRestricted: !org.canSetVisibility('enterprise')
        publicRestricted: !org.canSetVisibility('public')
        hasEnterprise: enterprise?
        enterpriseName: enterprise?.get('displayName')

    @

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')

    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    setting = $target.attr('name')

    if @options.idOrganizationSource
      @modelCache.get('Organization', @options.idOrganizationSource)?.boardList.remove(@model)
    @model.update({ idOrganization: @options.organization.id, 'prefs/permissionLevel': setting })
    @options.organization.boardList.add(@model)

    PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-org-select-perm-level-view.coffee